/**
 * Server-side prompt turn status: bridge queue rows and session DO `session_turns.status`.
 */

/** Bridge `bridge_prompt_turn_queue.server_state` values. */
export type BridgePromptTurnServerState =
  | 'queued'
  /** API-only: same prompt run is being retried (CLI treats like queued for dispatch). */
  | 'requeued'
  /** API-only: retry after reverting session parent to the pre-turn snapshot (CLI applies revert before prompt). */
  | 'requeued_with_revert'
  /** User asked to cancel; CLI should send ACP `session/cancel` for the running turn (mirrors session turn status). */
  | 'cancel_requested'
  | 'stopping'
  | 'discarded';

/** Session DO `session_turns.status` values relevant to prompt lifecycle. */
export type ServerSessionTurnStatus =
  | 'queued'
  | 'running'
  | 'stopping'
  | 'cancel_requested'
  | 'completed'
  | 'failed'
  | 'stopped'
  | string;

const BRIDGE_SERVER_STATES = new Set<BridgePromptTurnServerState>([
  'queued',
  'requeued',
  'requeued_with_revert',
  'cancel_requested',
  'stopping',
  'discarded',
]);

export function isBridgePromptTurnServerState(v: unknown): v is BridgePromptTurnServerState {
  return typeof v === 'string' && BRIDGE_SERVER_STATES.has(v as BridgePromptTurnServerState);
}

/** Bridge server states the CLI may start when no other turn is running in the queue file. */
export function isRunnableBridgePromptTurnServerState(state: BridgePromptTurnServerState): boolean {
  return state === 'queued' || state === 'requeued' || state === 'requeued_with_revert';
}
